<div class="p-1 relative font-weight-bold msg-expiracao" *ngIf="appDataService.$mostrarAviso | async">
  <div class="flex-x-btw flex-y-center">
    <div class="mb-0 px-1 text-center" fxFill [innerHTML]="(appDataService.diasEmFalta | async) | msgExpiracao"></div>
    <div (click)="desactivarAviso()" style="height: 30px; width: 30px; position: absolute; top: 17%; right: 15px; left: auto; cursor: pointer">
      <mat-icon>close</mat-icon>
    </div>
  </div>
</div>
<mat-toolbar class="topbar mat-bg-card">
  <!-- Sidenav toggle button -->
  <button
    *ngIf="layoutConf.sidebarStyle !== 'compact'"
    mat-icon-button
    id="sidenavToggle"
    (click)="toggleSidenav()"
    matTooltip="Toggle Hide/Open"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <span fxFlex></span>

  <!-- Language Switcher -->
   <!-- <button  mat-button [matMenuTriggerFor]="menu"> -->
<!--  </button>-->
<mat-menu #menu="matMenu">
</mat-menu>

  <!-- Open "views/search-view/result-page.component" to understand how to subscribe to input field value -->

  <!-- Top left user menu -->

  <button *ngIf="numeroNotificacoes>0 && userAdmin"
  mat-icon-button
  matTooltip="Notificações" 
  (click)="toggleNotific()"
  [style.overflow]="'visible'" 
  class="topbar-button-right">
    <mat-icon>notifications</mat-icon>
    <span class="notification-number mat-bg-warn">{{numeroNotificacoes}}</span>
  </button>
  
  <div  [matMenuTriggerFor]="accountMenu"
          class="user-profile-settings"
          style="display: flex"
  >
    <button *ngIf="this.fotoPerfil"  id="profile-avatar"  mat-icon-button  class="topbar-button-right img-button pr-0 mr-0 bg-light-gray" style="margin-right: 0 !important; overflow: hidden"
    >
      <img
              [src]="this.fotoPerfil | safe: 'resourceUrl'"
              alt=""
              style="width: 100% !important; height: auto !important"
      />
    </button>
    <button mat-button [disableRipple]="true" class="topbar-button-right pl-0">
      <span>{{utilizador?.nome || utilizador?.username}}</span>
    </button>
  </div>


  <mat-menu #accountMenu="matMenu">
    <button mat-menu-item [routerLink]="['/perfil/',loginService.decodedToken?.nameid]">
      <mat-icon>account_box</mat-icon>
      <span>Perfil</span>
    </button>

    <button mat-menu-item (click)="isCustomizerOpen = true" >
      <mat-icon>color_lens</mat-icon>
      <span>Aparência</span>
    </button>
    <button mat-menu-item  *ngIf="aplicacao && aplicacao?.codTipoInstalacao.toUpperCase() === 'D'" class="flex-y-center"  (click)="reloadWindow()" style="cursor: pointer">
      <mat-icon class="mr-05">sync</mat-icon>
      <span><small class="mr-05">Actualizar</small></span>
    </button>
    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Sair</span>
    </button>
  </mat-menu>
</mat-toolbar>


<app-customizer [isCustomizerOpen]="isCustomizerOpen" (fechar)="fecharCustomizer($event)"></app-customizer>
